The role of the owner of the position opening.

Currently, one code is defined:

- `Company` indicates a company hiring on behalf of themselves.
